import Splitting from "splitting";
import { gsap } from "gsap";
import { getAll } from "../utilities/querySelector";

export function splitCharacters(heading) {
    console.log(heading);
    Splitting({ target: heading, by: "chars" });
    const chars = getAll(".char", heading);
    let delayInMs = heading.getAttribute("data-aos-delay");
    if (delayInMs === null) {
        delayInMs = 0;
    }
    const delayInS = delayInMs / 1000;

    gsap.set(chars, { opacity: 0 });

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.attributeName === "class") {
                if (heading.classList.contains("aos-animate")) {
                    requestAnimationFrame(() => {
                        gsap.to(chars, {
                            delay: delayInS,
                            duration: 2,
                            opacity: 1,
                            x: 0,
                            stagger: 0.1,
                        });
                    });

                    observer.disconnect();
                }
            }
        });
    });

    observer.observe(heading, { attributes: true });
}